import React, { useCallback } from 'react'
import DaumPostCode, {Address} from 'react-daum-postcode';
import {Container} from "react-bootstrap";
import { PostModel, Window } from '../../model'
import useWindowDimensions from './UseWindowDimensions'

declare var window: Window;
export const RnPostCode = () => {
    const { height, width } = useWindowDimensions();
    const handleComplete = useCallback((data: Address) => {
        const param: PostModel = {post: data.zonecode, address: data.address, buildingName: data.buildingName};

        const rvalue = JSON.stringify(param);
        window.ReactNativeWebView.postMessage(rvalue)
        console.log(rvalue);  // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
    },[]);
   /* const handleSize=useCallback((size:Size)=>{
        console.log(`width:${size.width},height:${size.height}`);
    },[]);
*/
    return (
        <div className="bloc l-bloc" id="bloc-0">
            <Container className="bloc-sm">
                <div className="row">
                    <div className="col-sm-12">
                        <DaumPostCode
                            style={{height:height-50}}
                            onComplete={handleComplete}
                        />
                    </div>
                </div>
            </Container>
        </div>
    )
}

